import Hotjar from "@hotjar/browser";
import { v4 as uuid } from 'uuid';
export default function identifyHotjarUser() {
  const hjSessionId = localStorage.getItem("hj__");
  if (!hjSessionId) {
    const uniqueSession = uuid() + "_" + new Date().getTime() + "_HJ";
    localStorage.setItem("hj__", uniqueSession);
    Hotjar.identify(uniqueSession, {
      name: "Anonymous"
    });
    return uniqueSession;
  } else {
    Hotjar.identify(hjSessionId, {
      name: "Anonymous"
    });
    return hjSessionId;
  }
}